import {
    apiRequest,
    flexytimeDetail
} from "../../../../../services/adapters/kepegawaian/flexytimeService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", flexytimeDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository